// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2qd0z","ranges":"BmiRanges_ranges__3XW9z"};